import type { Menu, MenuCreateParams, MenuUpdateParams } from '../types/menu';

const STORAGE_KEY = 'task_management_menu_config_v1';

// System navigation follows the desktop sidebar even when an older menu is cached.
export const SYSTEM_MENU_ROUTES = [
  '/task/dashboard',
  '/task/assignee',
  '/task/today',
  '/task/week',
  '/task/next7Days',
  '/task/allTask',
  '/task/create',
  '/task/assigner',
  '/task/watched',
  '/task/search',
  '/task/screen',
  '/task/task-lists',
  '/task/tags',
  '/task/completed',
  '/task/active',
  '/task/report',
  '/task/recycle',
] as const;

export const SYSTEM_MENU_ICONS: Record<string, string> = {
  '/task/dashboard': 'DashboardOutlined',
  '/task/assignee': 'UserOutlined',
  '/task/today': 'CalendarOutlined',
  '/task/week': 'ScheduleOutlined',
  '/task/next7Days': 'FieldTimeOutlined',
  '/task/allTask': 'UnorderedListOutlined',
  '/task/create': 'FormOutlined',
  '/task/assigner': 'SendOutlined',
  '/task/watched': 'StarOutlined',
  '/task/search': 'SearchOutlined',
  '/task/screen': 'FundProjectionScreenOutlined',
  '/task/screen/all': 'FundProjectionScreenOutlined',
  '/task/task-lists': 'ProfileOutlined',
  '/task/task-lists/visible': 'ProfileOutlined',
  '/task/tags': 'TagsOutlined',
  '/task/tags/visible': 'TagsOutlined',
  '/task/completed': 'CheckCircleOutlined',
  '/task/active': 'HistoryOutlined',
  '/task/report': 'FileTextOutlined',
  '/task/recycle': 'DeleteOutlined',
};

const defaultMenus: Menu[] = [
  {
    id: 1,
    parent_id: null,
    name: '仪表盘',
    i18n_key: 'menu_dashboard',
    menu_type: 'item',
    icon: 'DashboardOutlined',
    route_path: '/task/dashboard',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 2,
    parent_id: null,
    name: '我负责的',
    i18n_key: 'menu_assigned_to_me',
    menu_type: 'item',
    icon: 'UserOutlined',
    route_path: '/task/assignee',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 3,
    parent_id: null,
    name: '今天',
    i18n_key: 'menu_today',
    menu_type: 'item',
    icon: 'CalendarOutlined',
    route_path: '/task/today',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 4,
    parent_id: null,
    name: '本周',
    i18n_key: 'menu_week',
    menu_type: 'item',
    icon: 'ScheduleOutlined',
    route_path: '/task/week',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 5,
    parent_id: null,
    name: '未来七天',
    i18n_key: 'menu_next_7_days',
    menu_type: 'item',
    icon: 'FieldTimeOutlined',
    route_path: '/task/next7Days',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 6,
    parent_id: null,
    name: '管理',
    i18n_key: 'menu_management',
    menu_type: 'submenu',
    icon: 'AppstoreAddOutlined',
    route_path: 'management',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 7,
    parent_id: 6,
    name: '全部任务',
    i18n_key: 'menu_all_tasks',
    menu_type: 'item',
    icon: 'UnorderedListOutlined',
    route_path: '/task/allTask',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 8,
    parent_id: 6,
    name: '我创建的',
    i18n_key: 'menu_my_created',
    menu_type: 'item',
    icon: 'FormOutlined',
    route_path: '/task/create',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 9,
    parent_id: 6,
    name: '我指派的',
    i18n_key: 'menu_my_assigned',
    menu_type: 'item',
    icon: 'SendOutlined',
    route_path: '/task/assigner',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 17,
    parent_id: 6,
    name: '我关注的',
    i18n_key: 'menu_my_watched',
    menu_type: 'item',
    icon: 'StarOutlined',
    route_path: '/task/watched',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 10,
    parent_id: 6,
    name: '搜索',
    i18n_key: 'menu_search',
    menu_type: 'item',
    icon: 'SearchOutlined',
    route_path: '/task/search',
    open_target: '_self',
    hidden: false,
    order_no: 1,
  },
  {
    id: 11,
    parent_id: 6,
    name: '活动',
    i18n_key: 'menu_activities',
    menu_type: 'item',
    icon: 'HistoryOutlined',
    route_path: '/task/active',
    open_target: '_self',
    hidden: false,
    order_no: 1,
  },
  {
    id: 12,
    parent_id: 6,
    name: '任务日报',
    i18n_key: 'menu_report',
    menu_type: 'item',
    icon: 'FileTextOutlined',
    route_path: '/task/report',
    open_target: '_self',
    hidden: false,
    order_no: 1,
  },
  {
    id: 13,
    parent_id: null,
    name: '大屏',
    i18n_key: 'menu_screen',
    menu_type: 'submenu',
    icon: 'FundProjectionScreenOutlined',
    route_path: '/task/screen',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 14,
    parent_id: null,
    name: '清单',
    i18n_key: 'menu_task_lists',
    menu_type: 'submenu',
    icon: 'ProfileOutlined',
    route_path: '/task/task-lists',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 15,
    parent_id: null,
    name: '标签',
    i18n_key: 'menu_tags',
    menu_type: 'submenu',
    icon: 'TagsOutlined',
    route_path: '/task/tags',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 16,
    parent_id: 6,
    name: '已完成',
    i18n_key: 'menu_completed',
    menu_type: 'item',
    icon: 'CheckCircleOutlined',
    route_path: '/task/completed',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
  {
    id: 18,
    parent_id: 6,
    name: '回收站',
    i18n_key: 'menu_recycle_bin',
    menu_type: 'item',
    icon: 'DeleteOutlined',
    route_path: '/task/recycle',
    open_target: '_self',
    hidden: false,
    order_no: 0,
  },
];

const canUseStorage =
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const cloneDefaultMenus = (): Menu[] =>
  defaultMenus.map((menu) => ({ ...menu }));

const getWatchedMenuTemplate = (id: number, parentId: number | null): Menu => ({
  id,
  parent_id: parentId,
  name: '我关注的',
  i18n_key: 'menu_my_watched',
  menu_type: 'item',
  icon: 'StarOutlined',
  route_path: '/task/watched',
  open_target: '_self',
  hidden: false,
  order_no: 0,
});

const isValidMenuType = (value: unknown): value is Menu['menu_type'] =>
  value === 'item' ||
  value === 'submenu' ||
  value === 'group' ||
  value === 'divider';

const normalizeStoredMenus = (value: unknown): Menu[] | null => {
  if (!Array.isArray(value) || value.length === 0) return null;

  const normalized = value
    .map((raw, index): Menu | null => {
      if (!raw || typeof raw !== 'object') return null;
      const item = raw as Partial<Menu>;
      const id =
        typeof item.id === 'number' && Number.isFinite(item.id)
          ? item.id
          : index + 1;
      const routePath =
        typeof item.route_path === 'string' ? item.route_path : '';

      return {
        id,
        parent_id:
          typeof item.parent_id === 'number' && Number.isFinite(item.parent_id)
            ? item.parent_id
            : null,
        name: typeof item.name === 'string' ? item.name : `menu-${id}`,
        i18n_key: typeof item.i18n_key === 'string' ? item.i18n_key : '',
        menu_type: isValidMenuType(item.menu_type) ? item.menu_type : 'item',
        icon: typeof item.icon === 'string' ? item.icon : null,
        route_path: routePath,
        permissions:
          typeof item.permissions === 'string' ? item.permissions : '',
        open_target: item.open_target === '_blank' ? '_blank' : '_self',
        hidden: Boolean(item.hidden),
        order_no:
          typeof item.order_no === 'number' && Number.isFinite(item.order_no)
            ? item.order_no
            : 0,
        created_at:
          typeof item.created_at === 'string' ? item.created_at : undefined,
        updated_at:
          typeof item.updated_at === 'string' ? item.updated_at : undefined,
      };
    })
    .filter((item): item is Menu => Boolean(item));

  if (!normalized.length) return null;

  const hasAtLeastOnePath = normalized.some(
    (item) => typeof item.route_path === 'string' && item.route_path.length > 0,
  );
  if (!hasAtLeastOnePath) return null;

  return normalized;
};

const patchMissingWatchedMenu = (menus: Menu[]): Menu[] => {
  const hasWatched = menus.some((item) => item.route_path === '/task/watched');
  if (hasWatched) return menus;

  const managementMenu = menus.find(
    (item) =>
      item.i18n_key === 'menu_management' ||
      item.name === '管理' ||
      item.route_path === 'management' ||
      item.route_path === '/task/management',
  );

  const nextId =
    menus.reduce((max, item) => Math.max(max, Number(item.id) || 0), 0) + 1;

  const watchedMenu = getWatchedMenuTemplate(
    nextId,
    managementMenu?.id ?? null,
  );

  const targetParentId = watchedMenu.parent_id;
  if (targetParentId) {
    const siblings = menus.filter((item) => item.parent_id === targetParentId);
    const anchorIndex = menus.findIndex(
      (item) =>
        item.parent_id === targetParentId &&
        item.route_path === '/task/assigner',
    );
    if (anchorIndex >= 0) {
      const next = [...menus];
      next.splice(anchorIndex + 1, 0, watchedMenu);
      return next;
    }
    if (siblings.length) {
      const lastSibling = siblings[siblings.length - 1];
      const insertAfter = menus.findIndex((item) => item.id === lastSibling.id);
      if (insertAfter >= 0) {
        const next = [...menus];
        next.splice(insertAfter + 1, 0, watchedMenu);
        return next;
      }
    }
  } else {
    const anchorIndex = menus.findIndex(
      (item) => item.route_path === '/task/assigner',
    );
    if (anchorIndex >= 0) {
      const next = [...menus];
      next.splice(anchorIndex + 1, 0, watchedMenu);
      return next;
    }
  }

  return [...menus, watchedMenu];
};

const readMenus = (): Menu[] => {
  if (!canUseStorage) return cloneDefaultMenus();

  let raw: string | null = null;
  try {
    raw = window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return cloneDefaultMenus();
  }

  if (!raw) return cloneDefaultMenus();

  try {
    const parsed = JSON.parse(raw);
    const normalized = normalizeStoredMenus(parsed);
    return patchMissingWatchedMenu(normalized ?? cloneDefaultMenus());
  } catch {
    return cloneDefaultMenus();
  }
};

const writeMenus = (menus: Menu[]) => {
  if (!canUseStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(menus));
  } catch {
    // 忽略存储异常（隐私模式/配额限制），以内存回退菜单继续运行
  }
};

export const menuConfigApi = {
  getDefaultMenus(): Menu[] {
    return cloneDefaultMenus();
  },

  async getMenuList(): Promise<{ menus: Menu[] }> {
    return { menus: readMenus() };
  },

  async createMenu(payload: MenuCreateParams): Promise<{ menu: Menu }> {
    const menus = readMenus();
    const nextId =
      menus.reduce((max, item) => Math.max(max, item.id ?? 0), 0) + 1;
    const now = new Date().toISOString();
    const menu: Menu = {
      ...payload,
      id: nextId,
      created_at: now,
      updated_at: now,
    };
    const nextMenus = [...menus, menu];
    writeMenus(nextMenus);
    return { menu };
  },

  async updateMenu(payload: MenuUpdateParams): Promise<{ menu: Menu | null }> {
    const menus = readMenus();
    const idx = menus.findIndex((item) => item.id === payload.id);
    if (idx < 0) return { menu: null };
    const next: Menu = {
      ...menus[idx],
      ...payload,
      updated_at: new Date().toISOString(),
    };
    menus[idx] = next;
    writeMenus(menus);
    return { menu: next };
  },

  async deleteMenu(id: number): Promise<void> {
    const menus = readMenus().filter(
      (item) => item.id !== id && item.parent_id !== id,
    );
    writeMenus(menus);
  },
};
